











































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Form, FormItem, Input } from 'element-ui';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import {
  ShipmentFields,
  ShipmentUpdateInput
} from '@/types/graphql/schemaTypes';
import get from 'lodash/get';

@Component({
  components: {
    UtcDatePicker,
    NullableInput,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class BlInfo extends Vue {
  @Prop() public shipment!: ShipmentFields;

  private editMode = false;
  private shipmentInput: ShipmentUpdateInput = {
    blMetaData: {
      blType: null,
      blNumber: null,
      numberOfOriginal: 0,
      numberOfCopy: 0,
      issueDate: null,
      issuePlace: null,
      houseBlNumber: null
    }
  } as ShipmentUpdateInput;

  private toggleEdit() {
    this.setShipmentInput(this.shipment);
    this.editMode = !this.editMode;
  }

  // restor prop values
  private cancel() {
    this.toggleEdit();
  }

  private submit() {
    this.$store.dispatch('Shipment/updateShipment', this.shipmentInput);
    this.toggleEdit();
  }

  private setShipmentInput(shipment: ShipmentFields) {
    // copy only the needed fields
    this.shipmentInput = {
      id: shipment.id,
      blMetaData: {
        blType: get(shipment, 'blMetaData.blType'),
        blNumber: get(shipment, 'blMetaData.blNumber'),
        numberOfOriginal: get(shipment, 'blMetaData.numberOfOriginal'),
        numberOfCopy: get(shipment, 'blMetaData.numberOfCopy'),
        issueDate: get(shipment, 'blMetaData.issueDate'),
        issuePlace: get(shipment, 'blMetaData.issuePlace'),
        houseBlNumber: get(shipment, 'blMetaData.houseBlNumber')
      }
    };
  }
}
